module.exports = __webpack_public_path__ + "img/chujishuimian_jpg_smzlpg.9ab614ce.png";